import React from 'react';
import { motion } from 'framer-motion';
import { SilenceIcon, FilterIcon, TempleIcon } from './Icons';
export function PillarsSection() {
  const pillars = [{
    icon: <SilenceIcon className="w-8 h-8 text-olive" data-id="element-228" />,
    title: 'PILAR 1: EL PROTOCOLO DE SILENCIO',
    problem: "Tu mente está saturada de dopamina digital. Cada vez que revisas el teléfono al despertar, le envías una señal a tu sistema nervioso: 'el mundo exterior es más importante que el mundo interior.'",
    solution: "El 'Ayuno de los Primeros 15' — los primeros 15 minutos del día sin tecnología de ningún tipo. Tan simple como transformador.",
    quote: 'El Espíritu Santo habla en un silbo apacible. No compite con el concierto de notificaciones. Espera ser buscado.'
  }, {
    icon: <FilterIcon className="w-8 h-8 text-olive" data-id="element-229" />,
    title: 'PILAR 2: EL MÉTODO DE LOS 3 FILTROS',
    problem: '¿Cómo sé si es Dios o mi imaginación? Esta pregunta honesta ha detenido a miles de buscadores sinceros.',
    solution: "Un marco de discernimiento espiritual basado en el carácter de Jesús. Cada pensamiento, cada 'impresión' en oración pasa por 3 filtros:",
    filters: [{
      name: 'Claridad',
      q: '¿Hay certeza interior o confusión?',
      a: 'La voz de Dios no paraliza; orienta'
    }, {
      name: 'Paz',
      q: '¿Trae paz incluso en la corrección?',
      a: 'No comodidad emocional; paz que sobrepasa el entendimiento'
    }, {
      name: 'Alineación',
      q: '¿Concuerda con el carácter de Jesús?',
      a: 'Si contradice la gracia del Evangelio, no viene de Él'
    }]
  }, {
    icon: <TempleIcon className="w-8 h-8 text-olive" data-id="element-230" />,
    title: 'PILAR 3: EL TABERNÁCULO ABIERTO',
    problem: '¿No sabéis que sois templo del Dios viviente?',
    solution: 'Llevar la Presencia al trabajo, los conflictos familiares y el descanso. Si la Presencia vive en ti, va a donde tú vas.',
    quote: 'Al trabajo. A las discusiones familiares. Al tráfico. Al supermercado. En ningún lugar de tu vida cotidiana estás fuera de Su presencia... a menos que lo olvides.'
  }];
  return <section className="bg-parchment py-24 px-4" data-id="element-231">
      <div className="max-w-5xl mx-auto" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-233">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark mb-6" data-id="element-234">
            Los 3 Pilares
          </h2>
          <p className="text-xl text-dark/70 max-w-3xl mx-auto" data-id="element-235">
            Después de años buscando una conexión real y estudiando las
            prácticas espirituales más transformadoras de la tradición
            cristiana, descubrí que la intimidad auténtica con Dios se construye
            sobre 3 pilares específicos que la religión institucional casi nunca
            enseña:
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-236">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-8 md:p-12 shadow-sm border border-gold/20 relative overflow-hidden" data-id="element-237">
              <div className="absolute top-0 left-0 w-2 h-full bg-gold" data-id="element-238" />

              <div className="flex items-center gap-4 mb-8" data-id="element-239">
                <div className="bg-gold/10 p-4 rounded-full" data-id="element-240">{pillar.icon}</div>
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-dark" data-id="element-241">
                  {pillar.title}
                </h3>
              </div>

              <div className="space-y-6 text-lg text-dark/80" data-id="element-242">
                <div data-id="element-243">
                  <strong className="text-accent-red uppercase text-sm tracking-wider block mb-2" data-id="element-244">
                    El Problema:
                  </strong>
                  <p data-id="element-245">{pillar.problem}</p>
                </div>

                <div data-id="element-246">
                  <strong className="text-olive uppercase text-sm tracking-wider block mb-2" data-id="element-247">
                    La Práctica / Solución:
                  </strong>
                  <p data-id="element-248">{pillar.solution}</p>
                </div>

                {pillar.filters && <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-249">
                    {pillar.filters.map((f, i) => <div key={i} className="bg-parchment p-4 rounded border border-dark/5" data-id="element-250">
                        <strong className="text-gold block mb-2" data-id="element-251">
                          {f.name}
                        </strong>
                        <p className="text-sm font-medium mb-2" data-id="element-252">{f.q}</p>
                        <p className="text-sm text-dark/60 italic" data-id="element-253">{f.a}</p>
                      </div>)}
                  </div>}

                {pillar.quote && <div className="mt-8 p-6 bg-olive/5 rounded-lg border-l-2 border-olive" data-id="element-254">
                    <p className="font-serif italic text-xl text-olive-dark" data-id="element-255">
                      "{pillar.quote}"
                    </p>
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}